import { Maybe } from 'graphql/jsutils/Maybe';
import React, { useRef } from 'react';
import useAssignFocus from '../../../Shared/Accessibility/hooks/useAssignFocus';
import { HomeHero_user } from '../Hero/__generated__/HomeHero';
import { useTitle } from './useTitle';

type Props = {
  firstName: Maybe<HomeHero_user['firstName']>;
};

const Header = ({ firstName }: Props) => {
  const title = useTitle(firstName);
  const headingRef = useRef<HTMLHeadingElement>(null);
  useAssignFocus(headingRef);

  return (
    <h1 ref={headingRef} tabIndex={-1} className="title-xl">
      {title}
    </h1>
  );
};

export default Header;
